// extracted by mini-css-extract-plugin
export const container = "loading-module--container--2N8Cl";